import { deadlinesFor, fieldsOf, type IPack, type IPackField } from '../../api/src/packs';

/**
 * What still stops a document's extra facts from being filed from Review: a date that isn't one,
 * a value that isn't one of the field's choices, a date that starts a deadline and is still empty
 * (a person always fills or confirms it), or the fact that sets how long that deadline is.
 */
export function extraProblems(f: { docType: string; extra?: { [fieldId: string]: string } }, pack: IPack): string[] {
  const fields: IPackField[] = fieldsOf(pack, f.docType);
  const problems: string[] = fields.flatMap((p: IPackField) => {
    const v: string = f.extra?.[p.id]?.trim() ?? '';
    if (p.kind === 'date' && v && !/^\d{4}-\d{2}-\d{2}$/.test(v)) {
      return [`${p.label}: use YYYY-MM-DD`];
    }
    if (p.choices && v && p.choices.indexOf(v) === -1) {
      return [`${p.label}: choose ${p.choices.join(' or ')}`];
    }
    return p.confirm && !v ? [p.label.toLowerCase()] : [];
  });
  for (const d of deadlinesFor(pack, f.docType, f.extra)) {
    const by: IPackField | undefined = fields.filter(p => p.id === d.deadline.days.field)[0];
    if (!d.date && by && problems.indexOf(by.label.toLowerCase()) === -1) {
      problems.push(by.label.toLowerCase());
    }
  }
  return problems;
}
